import { z } from "zod";

export const ConfigSchema = z.object({
  analytics_configurable: z.boolean(),
  cloud_providers: z.array(z.enum(["aws", "azure", "gcp", "tencentcloud"])),
  dev_flags: z.array(
    z
      .enum([
        "new-cost",
        "initiatives",
        "jun0",
        "admin-settings", // whether access model configuration is visible from Settings -> Access Model (TODO: FF name could be more specific)
        "ui-v2",
        "notification-rules",
        "operator-api",
      ])
      .optional(),
  ),
  customer: z.string(),
  is_poc: z.boolean(),
  private_instance: z.boolean(),
  segment_write_key: z.string(),
  sentry_enabled: z.boolean(),
  // Terraform opt-in letting SSO users create and manage their own API keys
  sso_api_keys: z.boolean().optional(),
  limited_visibility: z.boolean(),
  system_dashboards: z.boolean().optional(),
  hidden_dashboard_keys: z.array(z.string()).optional(),
});

export type AppConfig = z.infer<typeof ConfigSchema>;
